<template>
  <div class="scan-page">
    <!-- 顶部大图 -->
    <header class="hero">
      <img class="hero__img" src="@/assets/logo.jpg" />
      <div class="hero__mask"></div>
      <h1 class="hero__title">扫码核销</h1>
    </header>

    <!-- 主卡片 -->
    <section class="card">
      <div class="scan-area">
        <qrcode-stream
          v-if="cameraReady"
          @decode="onDecode"
          @init="onInit"
        ></qrcode-stream>
        <div v-else class="scan-placeholder">
          <i class="el-icon-camera"></i>
          <p>请打开相机扫码</p>
        </div>
      </div>

      <div class="actions">
        <el-button
          type="primary"
          icon="el-icon-camera"
          @click="openCamera"
          :disabled="cameraReady"
        >打开相机</el-button>
      </div>

    </section>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import { message } from 'element-ui';

export default {
  components: {
    QrcodeStream
  },
  data() {
    return {
      cameraReady: false,
      scanResult: ''
    };
  },
  methods: {
    openCamera() {
      this.cameraReady = true;
    },
    onDecode(result) {
      this.scanResult = result;
      this.$message.success({
            message: '扫码成功！',
            type: 'success',
            duration: 2000 // 提示显示的时长，单位为毫秒
          });
      // 调用API处理扫码结果
      this.callApi(result);
    },
    onInit(promise) {
      promise.then(() => {
        this.cameraReady = true;
      }).catch((error) => {
        message.error('无法打开相机，请检查权限');
        console.error('Error initializing camera:', error);
      });
    },
    callApi(qrCodeResult) {
      // 这里发送扫码结果到后端API
      console.log('Sending to API:', qrCodeResult);
      
      this.$axios.post('/api/scan-qr-code', { qrCodeResult })
        .then(response => {
          this.scanResult = response.data.message;
          if (response.data.code === 0) {
            this.$message.success("核销成功");
          } else {
            this.$message.error(response.data.message);
          }
          console.log(response);
        })
        .catch(error => {
          console.error('API调用失败', error);
          this.scanResult = '二维码内容错误或无法处理';
          this.$message.error(this.scanResult);
        });
    }
  }
};
</script>

<style scoped>
.scan-page {
  background: #f5f7fa;
  min-height: 100vh;
  padding-bottom: 80px;
}
/* 顶部 Hero */
.hero {
  position: relative;
  height: 180px;
  overflow: hidden;
  border-radius: 0 0 24px 24px;
}
.hero__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hero__mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
}
.hero__title {
  position: absolute;
  left: 24px;
  bottom: 24px;
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #ff9800;
}
/* 主卡片 */
.card {
  margin: -40px 16px 0;
  background: #fff;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}
.scan-area {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.scan-placeholder {
  text-align: center;
  color: #909399;
}
.scan-placeholder i {
  font-size: 48px;
}
.actions {
  display: flex;
  justify-content: center;
  gap: 20px;
}
.result {
  text-align: center;
  margin-top: 16px;
  font-size: 15px;
  color: #333;
}
</style>